class QuestionnaireApi {
    async createQuestionnaire(values, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/create`;
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify(values),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async getQuestionnaires(accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires`;
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }
    async getQuestionnairesByFormationId(formationId, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires?formation_id=${formationId}`;
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        const json = await resp.json();
        return json.data || [];
    }

    async updateQuestionnaire(values, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/update`;
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify(values),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async deleteQuestionnaire(id, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/delete`;
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify({ id }),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async getQuestionnaireById(id, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/${id}`;
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async getSessionsByFormationId(formationId, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/load-custom-report-selected-formation-data/${formationId}`;
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        const json = await resp.json();
        return json.sessions || [];
    }
    async getQuestions(questionnaireId, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/${questionnaireId}/questions`;
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async createQuestion(values, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questions/create`;
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify(values),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async updateQuestion(values, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questions/update`;
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify(values),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async deleteQuestion(id, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questions/delete`;
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify({ id }),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async sendByEmail(id, accessToken, formationId = null, sessionId = null) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/send`;
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify({ id, formation_id: formationId, session_id: sessionId }),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async duplicateQuestionnaire(id, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/duplicate`;
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify({ id }),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async fetchPublic(id, learnerId, tenant, sessionId = null) {
        let URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/public/${id}?learner_id=${learnerId}`;
        if (tenant) {
            URL += `&tenant=${tenant}`;
        }
        if (sessionId) {
            URL += `&session_id=${sessionId}`;
        }
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return await resp.json();
    }

    async submitQuestionnaire(payload, tenant) {
        let URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/submit`;
        if (tenant) {
            URL += `?tenant=${tenant}`;
        }
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return await resp.json();
    }
    async fetchSubmissions(id, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/${id}/submissions`;
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }
    async fetchSubmissionsByFilter(type, formationId, sessionId, accessToken) {
        let URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/submissions/filter?type=${type}`;
        if (formationId) URL += `&formation_id=${formationId}`;
        if (sessionId) URL += `&session_id=${sessionId}`;
        
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }
    async deleteSubmission(id, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/submissions/delete`;
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify({ id }),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async getSatisfactionSummaryBySession(sessionId, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/submissions/session-summary/${sessionId}`;
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }
    async getGlobalFormationsSatisfactionSummary(accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/satisfaction/formations-summary`;
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async getResponsesTrackingBySession(sessionId, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/responses-tracking/${sessionId}`;
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async getQuestionnairesStatusBySession(sessionId, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/session-status/${sessionId}`;
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async getCompletionCandidatesBySession(sessionId, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/completion-candidates/${sessionId}`;
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async createMissingQuestionnairesFromSession(targetSessionId, sourceSessionId, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/create-missing-from-session`;
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify({ targetSessionId, sourceSessionId }),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }
}

export const questionnaireApi = new QuestionnaireApi();
